<template>
  <div class="uk-container uk-margin-large-top">
    <h2>Request a Quote</h2>
    <form class="uk-form-stacked" @submit.prevent="submitForm">
      <div class="uk-margin">
        <label class="uk-form-label">Product</label>
        <input class="uk-input" type="text" :value="product" readonly />
      </div>
      <div class="uk-margin">
        <label class="uk-form-label">Your Name</label>
        <input class="uk-input" type="text" v-model="form.name" required />
      </div>
      <div class="uk-margin">
        <label class="uk-form-label">Email</label>
        <input class="uk-input" type="email" v-model="form.email" required />
      </div>
      <div class="uk-margin">
        <label class="uk-form-label">Your Message</label>
        <textarea class="uk-textarea" rows="4" v-model="form.message" placeholder="Please provide quantity or additional details"></textarea>
      </div>
      <button class="uk-button uk-button-primary" type="submit">Send</button>
    </form>
  </div>
</template>

<script>
export default {
  name: "QuoteForm",
  data() {
    return {
      product: this.$route.query.product || "",
      form: {
        name: "",
        email: "",
        message: "",
      },
    };
  },
  methods: {
    submitForm() {
      alert("Your quote request has been submitted!");
      // Gerçek gönderim eklenecekse: axios.post('/api/sendQuote', {...})
    }
  }
};
</script>
